import { render } from "./ReportsArchiveView.vue?vue&type=template&id=ffd8aab8&scoped=true"
import script from "./ReportsArchiveView.vue?vue&type=script&lang=js"
export * from "./ReportsArchiveView.vue?vue&type=script&lang=js"

import "./ReportsArchiveView.vue?vue&type=style&index=0&id=ffd8aab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd8aab8"]])

export default __exports__